import React from 'react';
import Modal from 'react-bootstrap-modal';

export default class ConfirmModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null,
            promiseReject: null
        };
    }

    open(title, message) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                message: message,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        if (result) {
            this.state.promiseResolve();
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null,
            promiseReject: null
        });
    }

    render() {
        return (
            <Modal show={this.state.isOpen} onHide={() => this.close(false)} aria-labelledby="ModalHeader" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>{this.state.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.state.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' onClick={() => this.close(true)}>Да</button>
                    <Modal.Dismiss className='btn btn-default'>Отмена</Modal.Dismiss>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/confirmModal.jsx